export const roundDiscountValue = (value: number | string) => {
    return parseFloat(Number(value).toFixed(2));
};
